import { observable, action } from "mobx"
import request from "app/vendor/request"
import config from "app/config"
import { getCurrentApp } from "app/api/localTools"
import ReportStore from "app/stores/azf/report"

export default class Store {
  @observable chartData = {
    count: [],
    size: [],
    report: []
  }
  @observable report = {}

  constructor(){
    this.report = ReportStore.fromJS()
  }

  @action getChartData = () => {
    request.get(`${config.backend}/${getCurrentApp()}/dashboard`)
    .checkToken()
    .commonDispose()
    .then((res) => {
      this.chartData = res
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/azf/dashboard.js